import { render, staticRenderFns } from "./documents-list.vue?vue&type=template&id=5006524e&"
import script from "./documents-list.vue?vue&type=script&lang=js&"
export * from "./documents-list.vue?vue&type=script&lang=js&"
import style0 from "./documents-list.vue?vue&type=style&index=0&id=5006524e&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5006524e')) {
      api.createRecord('5006524e', component.options)
    } else {
      api.reload('5006524e', component.options)
    }
    module.hot.accept("./documents-list.vue?vue&type=template&id=5006524e&", function () {
      api.rerender('5006524e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/documents/documents-list.vue"
export default component.exports